import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrow from "../../../components/BackArrow";
import { AppButton } from "../../../components";
import { fileUploadIcon } from "../../../icon/icon";
import { errorMessage } from "../../../helpers/messages";
import {
  checkCatchMessage,
  compressMediaFiles,
  isValidFileSelection,
  notify,
} from "../../../helpers/commonFunction";
import { insertRestaurantNotesInDB } from "../../Company/DBQuery";
import { routes } from "../../../helpers/constants";
import { useDispatch } from "react-redux";

const SummaryNotes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    type,
    selectedItem,
    selectedSubItem,
    selectedLocation,
    selectedRestaurant,
  } = location?.state || {};
  useEffect(() => {
    if (!selectedRestaurant?.id || !selectedItem?.id || !selectedSubItem?.id) {
      navigate(routes.siphoningSummary, {
        state: { ...location.state },
      });
    }
  }, []);

  const [formData, setFormData] = React.useState({
    notes: "",
    attachments: "",
    base64: "",
    isView: false,
  });

  useEffect(() => {
    if (selectedSubItem?.attachments || selectedSubItem?.base64) {
      setFormData({
        ...formData,
        attachments: selectedSubItem?.attachments,
        base64: selectedSubItem?.base64,
        notes: selectedSubItem?.notes,
        isView: true,
      });
    }
  }, [selectedSubItem]);

  const handleChangeValues = async (event, name) => {
    if (name === "notes") {
      setFormData({
        ...formData,
        notes: event?.target?.value,
      });
    } else {
      const target = event?.target;
      try {
        const files = target?.files;
        if (!files || files?.length === 0) {
          throw new Error(errorMessage.chooseImg);
        }
        const { isValid, message } = isValidFileSelection(files[0]);
        if (!isValid) {
          throw new Error(message);
        }
        const base64 = await compressMediaFiles(files[0], "file", "selfie");

        if (
          !base64 ||
          (typeof base64 === "string" && !base64?.includes("base64")) ||
          (typeof base64 === "object" && !base64?.size)
        ) {
          throw new Error(errorMessage.captureImg);
        }

        setFormData({
          ...formData,
          base64: base64,
          attachments: null,
          imageName: files[0]?.name || "",
        });
      } catch (error) {
        checkCatchMessage(error?.message || errorMessage.capture_selfie);
      } finally {
        if (target) {
          target.value = "";
        }
      }
    }
  };

  const checkValidation = () => {
    if (!formData?.notes) {
      notify(errorMessage.notes_req);
      return false;
    } else if (!formData.base64) {
      notify(errorMessage.attachment_req);
      return false;
    }
    return true;
  };

  const handleSubmitSummaryNote = async (isBack) => {
    try {
      if (formData?.isView || isBack) {
        setFormData({
          notes: "",
          attachments: null,
          base64: null,
          isView: false,
        });
        navigate(routes.siphoningSummary, {
          state: { ...location.state },
        });
        return;
      }

      if (!checkValidation()) return;
      const reqObj = {
        sub_item_id: selectedSubItem?.id,
        notes: formData?.notes,
        attachments: null,
        base64: formData?.base64,
        record_date: new Date(),
        location_id: selectedItem?.id,
        restaurant_id: selectedRestaurant?.restaurant_id,
      };

      const reqObjFinal = {
        reqObj: reqObj,
        currSItem: selectedItem,
        currSubItem: selectedSubItem,
        selectedLocation: selectedLocation,
        currSRestaurant: selectedRestaurant,
      };
      await insertRestaurantNotesInDB(reqObjFinal, dispatch, type);
      notify("Notes added successfully", "success");
      setFormData({
        notes: "",
        attachments: null,
        base64: null,
        isView: false,
      });
      navigate(routes.siphoningSummary, {
        state: { ...location.state },
      });
    } catch (error) {
      checkCatchMessage(error?.message || "Something went wrong!");
    }
  };

  return (
    <div className="tcl-raffles-makati-page tcl-summaty-page">
      <div className="tcl-raffles-makati-wrapper">
        <BackArrow handleClick={() => handleSubmitSummaryNote(true)} />

        <div className="tcl_notes_container">
          <div className="tcl_notes_content">
            <textarea
              name="remark"
              id="remark"
              value={formData.notes}
              placeholder="Enter notes"
              as="textarea"
              onChange={(e) => handleChangeValues(e, "notes")}
            />
          </div>
          <div className="tcl_notes_image_container">
            <input
              type="file"
              name="image"
              id="file"
              accept="image/jpeg, image/png"
              onChange={(e) => handleChangeValues(e)}
            />
            <label htmlFor="file" className="tcl_notes_attachment">
              {formData?.attachments || formData?.base64 ? (
                <div className="tcl_selected_file h-100 w-100">
                  <img
                    src={
                      formData?.base64?.includes("base64")
                        ? formData?.base64
                        : process.env.REACT_APP_IMAGE_URL +
                          formData?.attachments
                    }
                    alt="Note attachment"
                  />
                </div>
              ) : (
                <div className="tc-choose-content border-solid">
                  {fileUploadIcon}
                  <span className="tc-choose-text">Choose File to upload</span>
                </div>
              )}
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-3">
          <AppButton
            title={formData?.isView ? "Okay" : "Submit"}
            isBtnRed={true}
            onClick={() => handleSubmitSummaryNote()}
          />
        </div>
      </div>
    </div>
  );
};

export default SummaryNotes;
